import { useLocation, useNavigate } from "react-router-dom"
import { usePageTitle } from "../../../hooks"
import { useEffect, useRef, useState } from "react"
import { Constants, Format } from "../../../utils"
import { Box, Button, CircularProgress, Collapse, Grid, Typography } from "@mui/material"
import { ClientsService } from "../../../services/clients"
import { ISumulator } from "../../../utils/@interfaces"
import moment from "moment"
import Thumb from "../../../assets/img/logo with description.svg"
import { CCarousel, CCarouselItem, CImage } from "@coreui/react"

import Carrousel1 from "../../../assets/img/hotItWorks/1.jpeg"
import Carrousel2 from "../../../assets/img/hotItWorks/2.jpeg"
import Carrousel3 from "../../../assets/img/hotItWorks/3.jpeg"
import Carrousel4 from "../../../assets/img/hotItWorks/4.jpeg"
import Carrousel5 from "../../../assets/img/hotItWorks/5.jpeg"

const carrouselImages = [Carrousel1, Carrousel2, Carrousel3, Carrousel4, Carrousel5]

export const SimulatorLP = () => {
    usePageTitle("Detalhes das diárias")
    const navigate = useNavigate()
    const { state } = useLocation()

    const [data, setData] = useState<null | ISumulator>(null)
    const [loading, setLoading] = useState(true)

    const videoRef = useRef<HTMLVideoElement | null>(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.load();
        }
        getSimulation(Constants.creditEvolution[0])
    }, [])

    useEffect(() => {
        // importação do estilos do carousel
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/@coreui/coreui/dist/css/coreui.min.css';
        link.id = 'coreui-styles'; // ID para facilitar a remoção

        document.head.appendChild(link); // Adiciona o CSS ao <head>

        return () => {
            // remoção dos estilos do carousel que está dando conflito com o restante do site
            const existingLink = document.getElementById('coreui-styles');
            if (existingLink) {
                existingLink.remove();
            }
        };
    }, []);

    const getSimulation = (value: number) => {
        ClientsService.simulator(value)
            .then(({ data }) => setData(data))
            .finally(() => setLoading(false))
    }

    const handlePlay = () => {
        const video = videoRef.current;

        if (video) {
            if (video.requestFullscreen) {
                video.requestFullscreen();
            } else if ((video as any).webkitEnterFullscreen) {
                (video as any).webkitEnterFullscreen();
            } else if ((video as any).msRequestFullscreen) {
                (video as any).msRequestFullscreen();
            }
        }
    };

    const handleClick = () => {
        navigate("/enquete" + window.location.search, {
            state: {
                verified: true
            }
        })
    }

    useEffect(() => {
        if (data) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            })
        }
    }, [data])


    return (
        <>
            <Box
                sx={{
                    background: "linear-gradient(90deg, #1D22E6 0%, #01E7FE 100%)",
                    width: `calc(100% + 4rem)`,
                    ml: `-2rem`,
                    minHeight: "11.2rem",
                    padding: "2rem 1rem",
                    boxSizing: "border-box",
                    mt: "2rem"
                }}
                onClick={handleClick}
            >
                <Typography textAlign={"center"} fontSize={"1.8rem"} color="#FFFFFF">
                    Valor que você receberá em <strong>PIX NA HORA</strong>
                </Typography>

                <Typography textAlign={"center"} fontSize={"4rem"} color="#FFFFFF" fontWeight={800}>
                    {Format.currency(Constants.creditEvolution[0])}
                </Typography>
            </Box>

            <Typography fontSize={"1.4rem"} fontWeight={400} sx={{ opacity: .5 }} p={0} mt={2}>Simulação das diárias</Typography>

            <Collapse in={!!data && !loading}>
                <Grid
                    sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: ".3rem",
                        mt: "2rem"
                    }}
                >
                    <Typography color="warning" fontSize={"1.4rem"} textAlign={"center"} mb={"1rem"}>O valor das diárias diminuem a cada dia <span style={{ fontSize: "2rem" }}>&#129295;</span></Typography>
                    <Grid
                        key={"parcel-header"}
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            justifyContent: "space-between",
                            alignItems: "center",
                            boxSizing: "border-box",
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            borderRadius: "10px",
                            minHeight: "3.7rem",
                            padding: ".3rem 1rem",
                            border: "0.5px solid #00000040"
                        }}
                    >
                        <Typography fontSize={"1.6rem"} fontWeight={600}>Diárias</Typography>
                        <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5, ml: "-3rem" }} textAlign={"center"}>Vencimento</Typography>
                        <Typography fontSize={"1.6rem"} fontWeight={700} color="secondary">Valor</Typography>
                    </Grid>
                    {data?.parcels?.map((parcel) => {
                        return (
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    boxSizing: "border-box",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    borderRadius: "10px",
                                    minHeight: "3.7rem",
                                    padding: ".3rem 1rem",
                                    border: "0.5px solid #00000040"
                                }}
                            >
                                <Typography fontSize={"1.6rem"} fontWeight={600}>{parcel.index} de 24</Typography>
                                <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5 }} textAlign={"center"}>Venc.: {moment(parcel.date).format("DD/MM/YY")}<br />{moment(parcel.date).format("[(]dddd[)]")}</Typography>
                                <Typography fontSize={"1.6rem"} fontWeight={700} color="secondary">{Format.currency(parcel.totalToPay)}</Typography>

                            </Box>
                        )
                    })}
                </Grid>
            </Collapse>
            {loading &&
                <Grid display={"flex"} alignItems={"center"} justifyContent={"center"}>
                    <CircularProgress />
                </Grid>
            }

            <Typography color="primary" mt={"4rem"} fontSize={"2rem"} fontWeight={700} textAlign={"center"} onClick={handleClick}>Clique aqui para solicitar {Format.currency(Constants.creditEvolution[0])} agora!</Typography >

            <Button
                variant="contained"
                sx={{
                    background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",
                    fontSize: "2rem",
                    fontWeight: "600",
                    maxWidth: "29.4rem",
                    minHeight: "4.4rem",
                    padding: ".9rem",
                    animation: "pulse 1s infinite",
                    alignSelf: "center",
                    mt: "2rem"
                }}
                onClick={handleClick}
            >Solicitar {Format.currency(Constants.creditEvolution[0])} agora!</Button>

            <Typography mt={"2rem"} fontSize={"1.6rem"} fontWeight={600} textAlign={"center"}>Assista o vídeo e saiba como funciona</Typography>


            <video ref={videoRef} controls controlsList="nodownload" preload="auto" poster={Thumb} onPlay={handlePlay} style={{
                maxWidth: '100%',
                borderRadius: "20px"
            }}>
                <source src={"https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/GYROO+-+COMO+FUNCIONA.mp4"} type="video/mp4" />
            </video>

            <Button
                variant="contained"
                onClick={handleClick}
                sx={{
                    width: "100%",
                    animation: "pulse 2s infinite",
                    background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",

                }}
            >Solicite seu crédito aqui</Button>

            <Typography fontSize={"2rem"} fontWeight={600} mt={"2rem"} p={0}>Como funciona?</Typography>

            <CCarousel controls indicators transition="slide" style={{
                width: "100%"
            }}>
                {carrouselImages.map((item, index) =>
                    <CCarouselItem key={"slide-" + index}>
                        <CImage style={{
                            display: "block",
                            width: "100%"
                        }} src={item} alt={"slide " + index + 1} />
                    </CCarouselItem>
                )}
            </CCarousel>
        </>
    )

}